let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7nZOc")).then(() => parcelRequire('7n1Yj'));